var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBathbig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24.695pt",
    height: "20.578pt",
    viewBox: "0 0 24.695 20.578",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6e-4,1.9e-4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0.44138 0.25v0.25h23.371l-11.465 19.109-11.691-19.488-0.21485 0.1289v0.25-0.25l-0.21093 0.12891 12.117 20.199 12.348-20.578h-24.695l0.23047 0.37891",
    fill: "#231f20"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBathbig);
export default __webpack_public_path__ + "static/media/bathbig.cc518a0fc43d254897a5bac090d99a4a.svg";
export { ForwardRef as ReactComponent };